import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../../api/services/user';

export const fetchOrders = createAsyncThunk('order/fetchOrders', async page => {
  return await userService.fetchOrders(page);
});

export const fetchOrder = createAsyncThunk('order/fetchOrder', async id => {
  return await userService.fetchOrder(id);
});

export const setOrderState = createAsyncThunk('order/setOrderState', async ({ id, data }) => {
  return await userService.setOrderState(id, data);
});
